import { render, staticRenderFns } from "./ExamDeferral.vue?vue&type=template&id=dd64ab32&scoped=true"
import script from "./ExamDeferral.vue?vue&type=script&lang=js"
export * from "./ExamDeferral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd64ab32",
  null
  
)

export default component.exports